import apiFactory from '../config/api-factory';
import {
  UserStudioAccessResponse,
  UserPublishAccessResponse,
} from '../models/user-permissions/types';

class UserPermissionsService {
  getStudioAccess = () => {
    return apiFactory.v2.get<UserStudioAccessResponse>(
      '/policies/studio_access'
    );
  };

  getPublishAccess = () => {
    return apiFactory.v2.get<UserPublishAccessResponse>(
      '/policies/publish_access'
    );
  };
}

export default UserPermissionsService;
